import React from "react";
import { useGetAllowedExtensionsQuery } from "@/react/services/common/extensionsApi";
import { useSelector } from "react-redux";
import { pbxIdSelector } from "@/react/features/customer/customerSlice";
import DynamicSelectCell from "./DynamicSelectCell";

const ExtensionsSelect = (props) => {
  const pbxId = useSelector(pbxIdSelector);

  const { data, isFetching } = useGetAllowedExtensionsQuery(pbxId);

  const options = (data || []).map((extension) => ({
    value: extension.extensionNumber,
    label: extension.extensionNumber,
  }));

  return (
    <DynamicSelectCell
      {...props}
      options={options}
      isFetching={isFetching}
      testId={"extension-select"}
      placeholder={"Select Extension"}
    />
  );
};

export default ExtensionsSelect;
